<template>
  <div class="goods-authorized">
    <SearchComponent
      ref="search"
      @updateData="_updateData"
      :condition="condition"
      :routeName="$route.name"
    />
    <TableComponent
      :btn="false"
      :tableData="tableData"
      @updateData="_updateData"
      :routeName="$route.name"
      :pagination="pagination"
    >
      <template #default="{jumpRoute,handleSelectionChange,editor}">
        <el-table
          :data="tableData"
          v-min-height
          @selection-change="handleSelectionChange"
          header-cell-class-name="theader-th"
          cell-class-name="tbody-td"
          :height="500"
        >
          <el-table-column align="center" width="130" type="selection" fixed />
          <el-table-column align="left" min-width="400" label="企业名称">
            <template slot-scope="scope">
              <p>
                {{ scope.row.companyCnName }}
              </p>
              <p>
                {{ scope.row.companyEnName }}
              </p>
            </template>
          </el-table-column>
          <el-table-column
            align="left"
            min-width="300"
            label="统一社会信用代码"
          >
            <template slot-scope="scope">
              <p>{{ scope.row.code }}</p>
              <p>营业执照时间： {{ scope.row.time }}</p>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            min-width="180"
            label="跨境商品"
            prop="crossNum"
          />
          <el-table-column
            align="center"
            min-width="180"
            label="完税商品"
            prop="dutyNum"
          />
          <el-table-column
            align="center"
            min-width="180"
            fixed="right"
            label="操作"
            class-name="visible"
          >
            <template slot-scope="scope">
              <el-button
                v-permission:details="$route.meta.permission"
                class="iconfont icon-chakanxiangqing d5"
                round
                @click="jumpRoute(scope.row)"
                size="36"
              />
              <el-button
                v-permission:authorized="$route.meta.permission"
                class="sub-color"
                size="96"
                v-html="'授权'"
                @click="editor(scope.row)"
              />
            </template>
          </el-table-column>
        </el-table>
      </template>
    </TableComponent>
  </div>
</template>
<script>
import SearchComponent from '../Components/SearchComponent'
import TableComponent from '../Components/TableComponent'
import updateData from 'mixins/updateData'

export default {
  name: 'goodsAuthorized',
  mixins: [updateData],
  components: {
    SearchComponent,
    TableComponent
  },
  data() {
    this.keyMap = {
      merchant_list: {
        name: 'tableData',
        credit_code: 'code',
        enterprise_en_name: 'companyEnName',
        enterprise_name: 'companyCnName',
        merchant_id: 'id',
        license_date: 'time',
        cross_goods_number: 'crossNum',
        duty_goods_number: 'dutyNum',
        goods_total_number: 'totalNum'
      }
    }
    return {
      condition: {},
      tableData: [],
      pagination: {
        currentPage: 1,
        pageTotal: 19,
        recordTotal: 80
      }
    }
  },
  created() {
    this._getGoodsAuthorizedList({
      curpage: 1
    })
  },
  methods: {
    /**
     * 获取列表
     * @params
     * @private
     */
    _getGoodsAuthorizedList(params) {
      this.api.getGoodsAuthorizedList(params).then(res => {
        this.utils.setCommonCode(res, this)
      })
    }
  }
}
</script>
